import { put, all, takeLatest, select } from 'redux-saga/effects';

import { OBTER_MENU_ATENDIMENTO_VIRTUAL_REQUEST } from './constants';
import { obterMenuAtendimentoVirtualSuccess } from './actions';
import { PersonalizacaoService } from '../../../common/services/personalizacao';

function* obterMenuAtendimentoVirtual() {
  const service = new PersonalizacaoService();
  const { plano, listaPlanos } = yield select((state) => state.user);

  const { sitpart, tipoBeneficio } = listaPlanos.find(
    (plan) => Number(plan.value) === Number(plano)
  );

  const telas = yield service.getMenuAtendimentoVirtual(
    plano,
    sitpart,
    tipoBeneficio
  );

  yield put(obterMenuAtendimentoVirtualSuccess(telas));
}

export default all([
  takeLatest(
    OBTER_MENU_ATENDIMENTO_VIRTUAL_REQUEST,
    obterMenuAtendimentoVirtual
  ),
]);
